(function ($) {
  'use strict';

  var timer = null;

  function formatMoneyIdr(cents) {
    return 'Rp' + Math.round((cents || 0) / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function updateFreebieProgress(cart) {
    var bars = document.querySelectorAll('.cart-freebie');
    if (!bars.length || !cart) return;

    bars.forEach(function (el) {
      var threshold = parseInt(el.getAttribute('data-threshold'), 10) || 0;
      var freebieLine = 0;
      var hasFreebie = false;

      if (cart.items && cart.items.length) {
        cart.items.forEach(function (item) {
          var props = item.properties || {};
          if (props._freebie === 'true' || props._freebie === true) {
            freebieLine += item.final_line_price || 0;
            hasFreebie = true;
          }
        });
      }

      var eligible = (cart.total_price || 0) - freebieLine;
      var remaining = threshold - eligible;
      var percent = threshold > 0 ? Math.round((eligible * 100) / threshold) : 100;
      if (percent > 100) percent = 100;
      if (percent < 0) percent = 0;

      el.setAttribute('data-eligible-total', String(eligible));
      el.setAttribute('data-has-freebie', hasFreebie ? 'true' : 'false');

      var textEl = el.querySelector('[data-freebie-message]');
      if (textEl) {
        if (hasFreebie || remaining <= 0) {
          textEl.textContent = 'Kamu sudah berhak mendapatkan 1 produk gratis!';
        } else {
          textEl.textContent =
            'Tambahkan ' + formatMoneyIdr(remaining) + ' untuk mendapatkan 1 produk gratis';
        }
      } else {
        textEl = el.querySelector('.cart-freebie__top > span:first-child');
        if (textEl) {
          if (remaining > 0) {
            textEl.textContent =
              'Tambahkan ' + formatMoneyIdr(remaining) + ' untuk mendapatkan 1 produk gratis';
          } else {
            textEl.textContent = "You're eligible for freebies!";
          }
        }
      }

      var progress = el.querySelector('.cart-freebie__progress span');
      if (progress) progress.style.width = percent + '%';
    });
  }

  window.updateFreebieProgress = updateFreebieProgress;

  function updateCartBadge() {
    $.getJSON('/cart.js', function (cart) {
      var $badges = $('.header-action-btn__badge');
      $badges.text(cart.item_count);
      if (cart.item_count > 0) {
        $badges.show();
      } else {
        $badges.hide();
      }
      updateFreebieProgress(cart);
    });
  }

  function triggerSuccessToast() {
    updateCartBadge();

    // Scroll smoothly to top
    $('html, body').animate({ scrollTop: 0 }, 400);

    // Show popover
    var $popover = $('#cart-toast-popover');
    $popover.addClass('is-show');

    if (timer) clearTimeout(timer);
    timer = setTimeout(function () {
      $popover.removeClass('is-show');
    }, 5000);
  }

  // Universal click listener for ALL Add To Cart buttons on the entire site
  $(document).on('click', 'button, a, input[type="submit"]', function (e) {
    var $btn = $(this);

    // PDP has its own ATC handler in product.js (toast + freebie progress)
    if ($btn.is('[data-pdp-atc]')) return;

    var text = ($btn.text() || $btn.val() || '').trim().toLowerCase();

    // Check if this button is an Add To Cart button
    var isAtcBtn = text.indexOf('add to cart') !== -1 ||
      text.indexOf('tambahkan ke keranjang') !== -1 ||
      $btn.is('[data-atc-id], [data-vp-atc], .product-card__cta, .our-bestseller-card__add-btn, .best-sellers-card__button, .variant-popup__atc');

    if (!isAtcBtn) return;

    // If it opens a variant modal popup, let the popup script open it first
    if ($btn.attr('data-vp-open')) return;

    e.preventDefault();

    // Find variant ID
    var variantId = $btn.attr('data-atc-id') || $btn.attr('data-variant-id');
    if (!variantId) {
      var $parent = $btn.closest('.product-card, .variant-popup, form, .product-single, section');
      variantId = $parent.find('[name="id"]').val() ||
        $parent.find('[data-card-variant-id]').data('card-variant-id') ||
        $parent.find('[data-variant-id]').data('variant-id');
    }

    // Find quantity
    var qty = parseInt($btn.closest('form, section, div').find('[name="quantity"], [data-pdp-qty]').val(), 10) || 1;

    if (variantId) {
      $btn.addClass('is-loading').prop('disabled', true);

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: JSON.stringify({ id: variantId, quantity: qty }),
        contentType: 'application/json',
        dataType: 'json'
      })
        .done(function () {
          triggerSuccessToast();
        })
        .fail(function (jqXHR) {
          var res = jqXHR.responseJSON;
          var msg = (res && res.description) ? res.description : 'Could not add to cart.';
          alert(msg);
        })
        .always(function () {
          $btn.removeClass('is-loading').prop('disabled', false);
        });
    } else {
      // Fallback if form submit is standard Shopify form
      var $form = $btn.closest('form[action*="/cart/add"]');
      if ($form.length) {
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: $form.serialize(),
          dataType: 'json'
        })
          .done(function () {
            triggerSuccessToast();
          })
          .fail(function (jqXHR) {
            var res = jqXHR.responseJSON;
            var msg = (res && res.description) ? res.description : 'Could not add to cart.';
            alert(msg);
          });
      }
    }
  });

  $(document).on('click', '#cart-toast-close', function (e) {
    e.preventDefault();
    $('#cart-toast-popover').removeClass('is-show');
    if (timer) clearTimeout(timer);
  });

})(jQuery);

// search suggestion
document.addEventListener("DOMContentLoaded", function () {
  const searchInput = document.getElementById("search-input");
  const searchResult = document.getElementById("search-results");
  const suggestionWrapper = document.querySelector(".collection-search-suggestion-wrapper");

  function toggleSearchContent() {
    const keyword = searchInput.value.trim();

    if (keyword.length > 0) {
      searchResult.style.display = "block";
      if (suggestionWrapper) {
        suggestionWrapper.style.display = "none";
      }
    } else {
      searchResult.style.display = "none";

      if (suggestionWrapper) {
        suggestionWrapper.style.display = "block"
      }
    }
  }

  toggleSearchContent();


  searchInput.addEventListener("input", toggleSearchContent)
})